(function () {
    'use strict';

    angular
        .module('app.influencerOverview')
        .controller('influencerOverviewCtrl', influencerOverviewCtrl);

    influencerOverviewCtrl.$inject = ['$scope', '$rootScope', '$compile', 'influencerOverviewService', '$http', '$controller', '$stateParams', 'localStorageService', '$modal', 'adminService', '$location', '$state'];
    /* @ngInject */
    function influencerOverviewCtrl($scope, $rootScope, $compile, influencerOverviewService, $http, $controller, $stateParams, localStorageService, $modal, adminService, $location, $state) {

        $scope.currentUser = $rootScope.currentUser;
        $scope.saveParams = null;
        $scope.firstLoad = true;
        $scope.enableDropdownList = false;
        $scope.influencer = null;
        $scope.influencerName = null;
        $scope.inflluencerId = null;
        $scope.influencerNetwork = null
        $scope.telephone = null;
        $scope.email = null;
        var ls = localStorageService;

        $scope.timeline = [
            { label: 'Last 7 days', value: 7, ticked: true },
            { label: 'Last 15 days', value: 15 },
            { label: 'Last 30 days', value: 30 },
            { label: 'Last 60 days', value: 60 },
            /*{ label: 'Last 90 days', value: 90 }*/
        ];

        $scope.mentionsShowed = [
            { label: 'Keywords and Urls', value: 0 },
            { label: 'Urls and Hashtags', value: 1 },
            { label: 'Keywords and Hashtags', value: 2 },
        ];

        if ($rootScope.selectedPeriod.period != null) {
            angular.forEach($scope.timeline, function (item) {
                if (item.value == $rootScope.selectedPeriod.period.value) {
                    item.ticked = true;
                } else {
                    item.ticked = false;
                }
            })
        } else {
            $rootScope.selectedPeriod.period = {
                label: 'Last 7 days', value: 7, ticked: true
            }
        }

        if ($rootScope.currentUser.role.accessLevel == 'admin' || $rootScope.currentUser.role.accessLevel == 'agency' || $rootScope.currentUser.role.accessLevel == 'advertiser') {
            $scope.enableAddPrefered = true;
        } else {
            $scope.enableAddPrefered = false;
        }

        $scope.backInfluencer = function () {
            window.history.back();
        }

        $scope.changeActivityGraph = function (data) {
            $rootScope.selectedPeriod.period = data;
            $scope.loadInfluencerOverviewData();
            $rootScope.$broadcast('refreshDashboard', {});
        }

        var vm = this;

        $scope.activityChart = {
            options: {
                chart: {
                    type: 'line',
                    zoomType: 'x',
                    events: {
                        redraw: function () {
                            $('.highcharts-markers').attr('visibility', 'hidden');
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    line: {
                        marker: {
                            enabled: true,
                            symbol: "circle",
                            fillColor: "#fff",
                            lineColor: null,
                            lineWidth: 3,
                            radius: 4,
                            states: {
                                hover: {
                                    enabled: true,
                                    symbol: "circle",
                                    fillColor: "#fff",
                                    lineColor: "#000",
                                    lineWidth: 3,
                                    radius: 4
                                }
                            }
                        },
                        events: {
                            mouseOver: function (event) {
                                this.markerGroup.attr('visibility', 'visible');
                            },
                            mouseOut: function (event) {
                                this.markerGroup.attr('visibility', 'hidden');
                            }
                        }
                    }
                },
                tooltip: {
                    useHTML: true,
                    followPointer: false,
                    backgroundColor: "#333b48",
                    pointFormatter: function () {
                        return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                    },
                    headerFormat: "",
                    borderRadius: 24,
                    borderWidth: 0,
                    shadow: false,
                    shape: "callout",
                    style: {
                        "color": "#FFFFFF",
                        "padding": "6"
                    }
                }
            },
            series: [],
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime',
                labels: {
                    useHTML: true,
                    format: "{value:%d %b}",
                    style: {
                        fontFamily: "ProximaNovaRegular",
                        letterSpacing: "1px",
                        paddingTop: "10px",
                        textTransform: "uppercase",
                    }
                },
                tickLength: 0
            },
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, 0, ',');
                    },
                    style: {
                        fontFamily: "ProximaNovaRegular",
                    }
                }
            },
            noData: 'Pending Data...',
            loading: true
        };

        var pieChartConfigHaveLegend = {
            options: {
                chart: {
                    type: 'pie',
                    backgroundColor: null,
                    marginBottom: 1,
                    marginLeft: 0,
                    marginRight: 200,
                    marginTop: 0
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true
                    }
                },
                credits: {
                    enabled: false
                },
                legend: {
                    verticalAlign: 'middle',
                    align: 'right',
                    layout: 'vertical',
                    width: 170,
                    itemStyle: {
                        fontWeight: '500'
                    },
                    labelFormatter: function () {
                        return '<span style="display: block">'
                            + this.name + ' - '
                            + Math.round(Math.round(this.y * 1000)) / 10 + '%' +
                            '</span>';
                    }
                }
            },
            series: [{
                size: '100%',
                innerSize: '85%'
            }],
            title: {
                text: 'MOST USED TOPICS',
                style: {
                    fontSize: '13px',
                    color: '#4B5567',
                    fontWeight: 'bold',
                    fontFamily: 'ProximaNovaRegular'
                },
                align: 'left'
            },
            xAxis: {
                type: 'datetime',
                title: {
                    text: 'Date'
                }
            },
            noData: 'Pending Data...',
            loading: true
        };

        var barChartConfig = {
            options: {
                chart: {
                    type: 'column',
                    zoomType: 'x'
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        //stacking: 'normal',
                        dataLabels: {
                            enabled: false
                        },
                        //pointWidth: 20,
                        showInLegend: false
                    },
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            allowOverlap: true,
                            enabled: true,
                            crop: false,
                            overflow: 'none',
                            format: '{point.y:.0f}'
                        },
                        pointWidth: 40,
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    }
                },
                credits: {
                    enabled: false
                }
            },
            series: [],
            title: {
                text: 'TOPIC VS ENGAGEMENT',
                textAnchor: 'left',
                style: {
                    fontSize: '13px',
                    color: '#4B5567',
                    fontWeight: 'bold',
                    fontFamily: 'ProximaNovaRegular'
                }
            },
            xAxis: {
                type: 'category',
                tickLength: 0,
                labels: {

                }
            },
            yAxis: {
                title: {
                    text: false
                },
                labels: {
                    enabled: false
                }
            },
            noData: 'Pending Data...',
            loading: true
        };

        var pieChartConfig = {
            options: {
                chart: {
                    type: 'pie',
                    zoomType: 'x',
                    backgroundColor: null,
                    marginBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0,
                    width: 40,
                    height: 40,
                    style: {
                        "overflow": "visible"
                    }
                },
                tooltip: {
                    useHTML: true,
                    followPointer: false,
                    hideDelay: 0,
                    backgroundColor: "#333b48",
                    headerFormat: "",
                    borderRadius: 24,
                    borderWidth: 0,
                    shadow: false,
                    shape: "callout",
                    style: {
                        "color": "#FFFFFF",
                        "padding": "6"
                    },
                    positioner: function (boxWidth, boxHeight, point) {
                        var chart = this.chart,
                            plotLeft = chart.plotLeft,
                            plotTop = chart.plotTop,
                            plotWidth = chart.plotWidth,
                            plotHeight = chart.plotHeight;
                        return { x: chart.plotLeft + chart.plotWidth / 2 - boxWidth / 2, y: chart.plotTop - boxHeight / 2 - 20 };
                    },
                    pointFormatter: function () {
                        if (this.name == 'Other') {
                            if (this.series.points[0].name == 'Impact') {
                                return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                            } else {
                                return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                            }

                        } else {
                            if (this.name == 'Impact') {
                                return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                            } else {
                                return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                            }

                        }
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: false,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: false
                    }
                },

                credits: {
                    enabled: false
                }
            },
            series: [{
                size: '31',
                innerSize: '25',
                states: {
                    hover: {
                        halo: {
                            size: 1
                        }
                    }
                }
            }],
            title: {
                text: '',
                style: {
                    fontSize: '13px',
                    color: '#4B5567',
                    fontWeight: 'bold',
                    fontFamily: 'ProximaNovaRegular'
                }
            },
            xAxis: {
                type: 'datetime',
                title: {
                    text: 'Date'
                }
            },
            noData: 'Pending Data...',
            loading: true
        };

        var linkNoImage = "/images/NoImage.png";
        $scope.slick_config = {
            autoplay: false,
            infinite: false,
            draggable: true,
            arrows: false,
            autoplaySpeed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true,
            method: {},
            event: {
                afterChange: function (event, slick, currentSlide, nextSlide) {
                    if (currentSlide == $scope.bloglists.length - 3 && !$scope.loading) {
                        if ($scope.bloglists.length == ($scope.slick_offset + $scope.slick_limit)) {
                            $scope.loading = true;
                            $scope.slick_offset = $scope.slick_offset + $scope.slick_limit;

                            var params = $scope.saveParams;
                            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
                            loadBlogs(params);
                        }
                    }
                }
            }
        };
        $scope.slick_category = "latest";
        $scope.slick_limit = 12;
        $scope.slick_offset = 0;
        $scope.loading = false;
        $scope.bloglists = [];

        $scope.loadInfluencerOverviewData = function () {
            if ($scope.firstLoad) {
                var url_getInfluencerDetails = $rootScope.apiUrl + 'admin/getInfluencerById/' + $stateParams.influencer_id;
                $http.get(url_getInfluencerDetails, { loader: false })
                    .success(function (response) {
                        $scope.influencer = response.data;
                        $scope.influencerName = response.data.domain;
                        $scope.influencerNetwork = response.data.network;

                        if ($scope.influencerNetwork != null) {
                            $scope.influencerNetworkName = $scope.influencerNetwork.name;
                            $scope.influencerNetworkPhone = $scope.influencerNetwork.phone;
                            $scope.influencerNetworkEmail = $scope.influencerNetwork.email;
                        } else {
                            $scope.influencerNetworkName = "N/A";
                            $scope.influencerNetworkPhone = null;
                            $scope.influencerNetworkEmail = $scope.influencer.systemEmail;
                        }

                        var params = {};
                        params.mention = 0;
                        params.blog_id = parseInt($scope.influencer.id);
                        params.project_id = 0;
                        params.channel = 0;
                        params.influencerGroup = 0;
                        if (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0) {
                            if ($scope.saveParams)
                                params = $scope.saveParams;
                            else
                                return;
                        } else {
                            $scope.saveParams = params;
                        }
                        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

                        getInfluencerOverviewLineChart(params);
                        getInfluencerOverviewKPIs(params);
                        getInfluencerPieChartAndBarChartData(params.blog_id, params.channel, params.date);
                        getInfluencerTopMentions(params.blog_id, params.date);
                        loadBlogs(params);
                        getChannelAudienceKPIs(params.blog_id);

                        var paramsInfluencerBlog = {
                            mention: 0,
                            blog_id: parseInt($scope.influencer.id),
                            project_id: 0,
                            channel: 0,
                            influencerGroup: 0,
                            date: params.date,
                            category: 'latest',
                            limit: 9,
                            offset: 0,
                        }

                        getInfluencerBlog(paramsInfluencerBlog);

                    }).error(function (data) {
                        $scope.influencerName = "failed load data";
                    })

                $scope.firstLoad = false;
            } else {
                var params = {};
                params.mention = 0;
                params.blog_id = parseInt($scope.influencer.id);
                params.project_id = 0;
                params.channel = 0;
                params.influencerGroup = 0;
                params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

                getInfluencerOverviewLineChart(params);
                getInfluencerOverviewKPIs(params);
                getInfluencerPieChartAndBarChartData(params.blog_id, params.channel, params.date);
                getInfluencerTopMentions(params.blog_id, params.date);
                loadBlogs(params);
                getChannelAudienceKPIs(params.blog_id);

                var paramsInfluencerBlog = {
                    mention: 0,
                    blog_id: parseInt($scope.influencer.id),
                    project_id: 0,
                    channel: 0,
                    influencerGroup: 0,
                    date: params.date,
                    category: 'latest',
                    limit: 9,
                    offset: 0,
                }

                getInfluencerBlog(paramsInfluencerBlog);
            }
        }

        function loadBlogs(params) {
            params.category = $scope.slick_category;
            params.limit = $scope.slick_limit;
            params.offset = $scope.slick_offset;

            var url = $rootScope.apiUrl + 'home/getHomePageBlogPosts?' + $.param(params);
            $http.get(url, { loader: false })
                .success(function (response) {
                    if (response.data != null) {
                        angular.forEach(response.data, function (item) {
                            var reachPieChartConfig = angular.copy(pieChartConfig);
                            reachPieChartConfig.series[0].name = item.name;
                            reachPieChartConfig.series[0].data = [{ name: 'Reach', color: '#FF6C9D', y: 0.5, value: _.get(item, 'reach') },
                            { name: 'Other', color: '#EEF2F4', y: 0.5, value: 0 }];

                            var engagementPieChartConfig = angular.copy(pieChartConfig);
                            engagementPieChartConfig.series[0].name = item.name;
                            engagementPieChartConfig.series[0].data = [{ name: 'Engagement', color: '#00D6EF', y: 0.5, value: _.get(item, 'engagement') },
                            { name: 'Other', color: '#EEF2F4', y: 0.5, value: 0 }];

                            var impactPieChartConfig = angular.copy(pieChartConfig);
                            impactPieChartConfig.series[0].name = item.name;
                            impactPieChartConfig.series[0].data = [{ name: 'Impact', color: '#4A5568', y: 0.5, value: _.get(item, 'impact') },
                            { name: 'Other', color: '#EEF2F4', y: 0.5, value: 0 }];

                            $scope.bloglists.push({
                                url: item.url,
                                relativepath: item.relativepath,
                                imageUrl: item.imageUrl == null || item.imageUrl == "" ? linkNoImage : item.imageUrl,
                                title: item.title,
                                influencerName: item.influencerName,
                                formatedDate: item.date,
                                mentions: item.mentions,
                                reach: item.reach,
                                engagement: item.engagement,
                                impact: item.impact,
                                reachPieChartConfig: reachPieChartConfig,
                                engagementPieChartConfig: engagementPieChartConfig,
                                impactPieChartConfig: impactPieChartConfig
                            });

                            var index = $scope.bloglists.length - 1;

                            var html = '<div class="col-md-4 blog-post">' +
                                '<p class="name-post"><a style="cursor: pointer;color: #444E5E;" ng-click="postOverviewPage(bloglists[' + index + '])">{{bloglists[' + index + '].title}}</a></p>' +
                                '<a href="{{bloglists[' + index + '].url}}" target="_blank">' +
                                '<div class="image-post" ng-attr-style="{{bloglists[' + index + '].imageUrl ? \'background-image: url(\' + bloglists[' + index + '].imageUrl + \')\' : \'\'}}"></div>' +
                                '</a>' +
                                '<div class="post-publish-date">' +
                                '<span><p class="publish-date">{{bloglists[' + index + '].formatedDate | date:"dd MMM yyyy"}}</p></span>' +
                                '<div class="blog-post-pie-charts">' +
                                '<highchart config="bloglists[' + index + '].reachPieChartConfig" class="influencer-blog-post" style="z-index:$index"></highchart>' +
                                '<highchart config="bloglists[' + index + '].engagementPieChartConfig" class="influencer-blog-post" style="z-index:$index"></highchart>' +
                                '<highchart config="bloglists[' + index + '].impactPieChartConfig" class="influencer-blog-post" style="z-index:$index"></highchart>' +
                                '</div>' +
                                '</div>' +
                                '<br>' +
                                '</div>';
                            var blogpost_html = $compile(html)($scope);
                            $('#blogposts').slick('slickAdd', blogpost_html);
                        });
                        $scope.loading = false;
                    }
                }).error(function (data) {

                });
        }

        $scope.postOverviewPage = function (index) {
            $rootScope.previousPagePost = $location.absUrl();
            var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + index.relativepath;
            $http.get(url_getPlatform)
                .success(function (response) {
                    if (response.data == 1) {
                        $state.transitionTo('home.blogPostOverview', { url: index.url, relativepath: index.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 2) {
                        $state.transitionTo('home.instagramPostOverview', { url: index.url, relativepath: index.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 6) {
                        $state.transitionTo('home.youtubePostOverview', { url: index.url, relativepath: index.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } else if (response.data == 7) {
                        $state.transitionTo('home.facebookPostOverview', { url: index.url, relativepath: index.relativepath }, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
                })
        }

        function getInfluencerOverviewLineChart(params) {
            influencerOverviewService.getInfluencerOverviewLineChart(params)
                .then(function (response) {
                    generateInfluencerOverviewLineChart(response.data);
                })
                .catch(function (msg) {
                    vm.activityLineChart.loading = false;
                    vm.activityLineChart.noData = "";
                    vm.activityLineChart.title.text = message + ". Failed to load data";
                })
                .finally(function () {

                });
        }

        function generateInfluencerOverviewLineChart(lineChartData) {
            $scope.activityChart.loading = true;

            var impressionsLine = { name: 'Impressions', data: [], color: '#55E9A9' };
            var reachLine = { name: 'Reach', data: [], color: '#FF6C9D' };
            var engagementLine = { name: 'Engagement', data: [], color: '#00D6EF' };

            angular.forEach(lineChartData, function (item) {
                angular.forEach(item, function (result) {
                    impressionsLine.data.push([result.date, Math.round(result.impressions)]);
                    reachLine.data.push([result.date, Math.round(result.reach)]);
                    engagementLine.data.push([result.date, Math.round(result.engagement)]);
                })
            })

            $scope.activityChart.series = [];
            $scope.activityChart.series.push(impressionsLine);
            $scope.activityChart.series.push(reachLine);
            $scope.activityChart.series.push(engagementLine);
            $scope.activityChart.loading = false;
            $scope.$broadcast('highchartsng.reflow');
            $scope.activityChart.title.text = "";
        }

        function getInfluencerOverviewKPIs(params) {
            influencerOverviewService.getInfluencerOverviewKPIs(params)
                .then(function (response) {
                    generateInfluencerOverviewKPIs(response.data.KPIs);
                })
                .catch(function (msg) {

                })
                .finally(function () {

                });
        }

        function getChannelAudienceKPIs(params) {
            influencerOverviewService.getChannelAudienceKPIs(params)
                .then(function (response) {
                    $scope.channelAudienceKPIs = response.data;
                    generateChannelAudienceKPIs($scope.channelAudienceKPIs.channelAudienceKPIs);
                })
                .catch(function (msg) {

                })
                .finally(function () {

                });
        }

        function truncateToDecimals(num, decPos) {
            var calcDec = Math.pow(10, decPos);
            return Math.trunc(num * calcDec) / calcDec;
        }

        function generateChannelAudienceKPIs(channels) {
            if (channels != null) {
                angular.forEach(channels, function (channel) {
                    channel.convertValue = (channel.value / 1000000) >= 1 ? truncateToDecimals(channel.value / 1000000, 1) + 'M' : (channel.value / 1000) > 1 ? Math.floor(channel.value / 1000) + 'K' : Math.round(channel.value);
                })
            }
        }

        function generateInfluencerOverviewKPIs(KPIs) {
            if (KPIs != null) {
                KPIs[2].value = (KPIs[2].value / 1000000) > 1 ? Math.floor(KPIs[2].value / 1000000) + 'M' : (KPIs[2].value / 1000) > 1 ? Math.floor(KPIs[2].value / 1000) + 'K' : Math.round(KPIs[2].value);
                KPIs[3].value = (KPIs[3].value / 1000000) > 1 ? Math.floor(KPIs[3].value / 1000000) + 'M' : (KPIs[3].value / 1000) > 1 ? Math.floor(KPIs[3].value / 1000) + 'K' : Math.round(KPIs[3].value);
                KPIs[4].value = Math.round(KPIs[4].value);
                $scope.influencerKPIs = KPIs;
                $scope.influencerKPIs.splice(0, 2);
                $scope.influencerKPIs.splice(1, 1);
            }
        }

        function getInfluencerBlog(params) {
            influencerOverviewService.getInfluencerBlog(params)
                .then(function (response) {
                    $scope.listInfluencerBlog = response.data;
                    generateInfluencerBlog($scope.listInfluencerBlog);
                })
                .catch(function (msg) {

                })
                .finally(function () {

                });
        }

        function generateInfluencerBlog(influencerPosts) {
            if (influencerPosts != null) {
                angular.forEach(influencerPosts, function (post) {
                    post.reach = (post.reach / 1000000) > 1 ? Math.floor(post.reach / 1000000) + 'M' : (post.reach / 1000) > 1 ? Math.floor(post.reach / 1000) + 'K' : Math.round(post.reach);
                    post.engagement = (post.engagement / 1000000) > 1 ? Math.floor(post.engagement / 1000000) + 'M' : (post.engagement / 1000) > 1 ? Math.floor(post.engagement / 1000) + 'K' : Math.round(post.engagement);
                    post.impressions = (post.impressions / 1000000) > 1 ? Math.floor(post.impressions / 1000000) + 'M' : (post.impressions / 1000) > 1 ? Math.floor(post.impressions / 1000) + 'K' : Math.round(post.impressions);
                    post.impact = Math.round(post.impact);
                })
            }
        }

        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        function getInfluencerPieChartAndBarChartData(blog_id, channel_id, date) {
            influencerOverviewService.getInfluencerPieChartAndBarChartData(blog_id, channel_id, date)
                .then(function (response) {
                    generateInfluencerPieChartAndBarChartData(response.industries);
                })
                .catch(function (message) {

                })
                .finally(function () {

                })
        }

        function generateInfluencerPieChartAndBarChartData(chartData) {
            var industries = {};

            var pieChart = _.get(chartData, 'pieChart');
            var barChart = _.get(chartData, 'barChart');

            if (pieChart && pieChart.length > 0 && barChart && barChart.length > 0){
                var config = angular.copy(pieChartConfigHaveLegend);
                config.options.chart.width = 450;
                config.options.chart.marginLeft = -10;
                config.options.legend.maxHeight = 232;
                config.options.legend.x = -35;
                config.options.legend.y = 5;
                config.options.legend.itemMarginBottom = 1.5;

                var dataPieChart = [];
                _.forEach(pieChart, function (item) {
                    if (item.name != "NA" && Math.round(item.value * 1000) / 10 != 0) {
                        dataPieChart.push({ name: item.name, y: item.value });
                    }
                });

                config.series[0].data = dataPieChart;
                config.series[0].size = '80%';
                config.title.style.marginBottom = '16px';
                config.title.x = 15;

                $scope.influencerTopicPieChart = config;

                var barConfig = angular.copy(barChartConfig);
                barConfig.options.chart.width = 450;
                barConfig.options.plotOptions.series.pointWidth = 25;
                barConfig.options.plotOptions.column.colorByPoint = true;
                barConfig.xAxis.labels.rotation = 90;
                barConfig.xAxis.labels.style = {
                    fontSize: '13px',
                    color: '#333333',
                    fontWeight: '600',
                    fontFamily: 'ProximaNovaRegular'
                };
                var barSeries = {
                    data: []
                };
                _.forEach(barChart, function (item) {
                    if (item.name != "NA" && Math.round(item.value) != 0) {
                        barSeries.data.push({ name: item.name, y: item.value });
                    }
                });
                barConfig.series.push(barSeries);
                $scope.influencerVerticalBarchart = barConfig;
                $scope.$broadcast('highchartsng.reflow');
            }
        }

        var topMentionsData = null;
        function getInfluencerTopMentions(blog_id, date) {
            influencerOverviewService.getInfluencerTopMentions(blog_id, date)
                .then(function (response) {
                    topMentionsData = response.topMentions;
                    generateInfluencerTopMentions(response.topMentions, 0);
                })
                .catch(function (message) {

                })
                .finally(function () {

                })
        }

        function generateInfluencerTopMentions(topMentions, indexNo) {
            $scope.topKW = 0;
            $scope.topURL = 0;
            $scope.topHASHTAG = 0;
            $scope.topMentionsKW = [];
            $scope.topMentionsURL = [];
            $scope.topMentionsHASHTAG = [];
            $scope.topMentionsKW.topMention = 0;
            $scope.topMentionsURL.topMention = 0;
            $scope.topMentionsHASHTAG.topMention = 0;
            $scope.topMentionsKW.name = topMentions.Keywords.name;
            $scope.topMentionsURL.name = topMentions.Urls.name;
            $scope.topMentionsHASHTAG.name = topMentions.Hashtags.name;

            function pushKeywords(Keywords) {
                var keywords = _.get(Keywords, 'value');
                _.forEach(keywords, function (item) {
                    $scope.topMentionsKW.push({ name: item.keyword, shortName: '', mentions: item.number });
                });
            }

            function pushUrls(Urls) {
                var urls = _.get(Urls, 'value');
                _.forEach(urls, function (item) {
                    $scope.topMentionsURL.push({ name: item.keyword, shortName: '', mentions: item.number });
                });
            }

            function pushHashtag(Hashtags) {
                var hashtags = _.get(Hashtags, 'value');
                _.forEach(hashtags, function (item) {
                    $scope.topMentionsHASHTAG.push({ name: item.keyword, shortName: '', mentions: item.number });
                });
            }

            function findMaxKeywordValue() {
                $scope.topMentionsKW.topMention = 0;
                angular.forEach($scope.topMentionsKW, function (kw) {
                    if (kw.name.length > 20) {
                        kw.shortName = kw.name.substring(0, 20) + "...";
                    } else {
                        kw.shortName = kw.name;
                    }
                    if (kw.mentions - $scope.topMentionsKW.topMention > 0) {
                        $scope.topMentionsKW.topMention = kw.mentions;
                    }
                });
            }

            function findMaxUrlValue() {
                $scope.topMentionsURL.topMention = 0;
                angular.forEach($scope.topMentionsURL, function (url) {
                    if (url.name.length > 20) {
                        url.shortName = url.name.substring(0, 20) + "...";
                    } else {
                        url.shortName = url.name;
                    }
                    if (url.mentions - $scope.topMentionsURL.topMention > 0) {
                        $scope.topMentionsURL.topMention = url.mentions;
                    }
                });
            }

            function findMaxHashtagValue() {
                $scope.topMentionsHASHTAG.topMention = 0;
                angular.forEach($scope.topMentionsHASHTAG, function (hashtag) {
                    if (hashtag.name.length > 20) {
                        hashtag.shortName = hashtag.name.substring(0, 20) + "...";
                    } else {
                        hashtag.shortName = hashtag.name;
                    }
                    if (hashtag.mentions - $scope.topMentionsHASHTAG.topMention > 0) {
                        $scope.topMentionsHASHTAG.topMention = hashtag.mentions;
                    }
                });
            }


            if (indexNo == 0) {
                $scope.topMentionsList = [];
                pushKeywords(topMentions.Keywords);
                pushUrls(topMentions.Urls);
                findMaxKeywordValue();
                findMaxUrlValue();
                $scope.topMentionsList.push($scope.topMentionsKW);
                $scope.topMentionsList.push($scope.topMentionsURL);


            } else if (indexNo == 1) {
                $scope.topMentionsList = [];
                pushUrls(topMentions.Urls);
                pushHashtag(topMentions.Hashtags);
                findMaxUrlValue();
                findMaxHashtagValue();
                $scope.topMentionsList.push($scope.topMentionsURL);
                $scope.topMentionsList.push($scope.topMentionsHASHTAG);
            } else {
                $scope.topMentionsList = [];
                pushKeywords(topMentions.Keywords);
                pushHashtag(topMentions.Hashtags);
                findMaxKeywordValue();
                findMaxHashtagValue();
                $scope.topMentionsList.push($scope.topMentionsKW);
                $scope.topMentionsList.push($scope.topMentionsHASHTAG);
            }
        }

        $scope.preloadData = function () {
            $scope.loadInfluencerOverviewData();
            $rootScope.$broadcast('refreshDashboard', {});
        }

        if ($scope.firstLoad) {
            $scope.preloadData();
        }

        $scope.addToPrefered = function () {

            $scope.selectedAdvertiserId = $rootScope.sideMenuSelections.advertiserId;

            if ($scope.selectedAdvertiserId == null) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "Please choose Advertiser!";

            } else {
                var preferedBlog = {
                    blog_id: $scope.influencer.id,
                    user_id: $scope.selectedAdvertiserId
                }

                var req = {
                    url: $rootScope.apiUrl + 'admin/addToPrefered',
                    method: 'POST',
                    data: JSON.stringify(preferedBlog)
                }
                $http(req)
                    .success(function (response) {
                        $rootScope.$broadcast('reload_advertiserPreferredList', { advertiserId: $scope.selectedAdvertiserId });
                    })
                    .error(function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }
        }

        $scope.addToCampaigns = function () {
            var addInfluencerToCampaignsInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/influencerOverview/addInfluencerToCampaigns/addInfluencerToCampaigns.html?app_v=deployDate',
                controller: 'advertiserAddInfluencerToCampaignsCtrl'
            });

            $scope.influencer_id = $scope.influencer.id;
            $scope.addInfluencerToCampaignsInstance = addInfluencerToCampaignsInstance;

            addInfluencerToCampaignsInstance.result.then(function () {
            });
        }

        $scope.toggleDropdownList = function () {
            $scope.enableDropdownList = !$scope.enableDropdownList;
        }

        $scope.$watch('selectedMentionsShowed', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue !== undefined && newValue.length != 0) {
                var indexNo = 0;
                for (var i = 0; i < $scope.mentionsShowed.length; i++) {
                    if (newValue[0].label.localeCompare($scope.mentionsShowed[i].label) == 0) {
                        indexNo = i;
                    }
                }
                generateInfluencerTopMentions(topMentionsData, indexNo);
            }
        });
    }
})();